// test1890
(1890 && 0);
